// start:ng42.barrel
export * from './hotel-brand-info.component';
// end:ng42.barrel



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/hotel-brand-info/index.ts